import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  draft: {
    defaultMessage: 'Draft',
    id: '4oBifm',
    description: 'Purchase Order Status Draft',
  },
  open: {
    defaultMessage: 'Open',
    id: 'CyVTOK',
    description: 'Purchase Order Status Open',
  },
  received: {
    defaultMessage: 'Received',
    id: 'lHZghC',
    description: 'Purchase Order Status Received',
  },
  closed: {
    defaultMessage: 'Closed',
    id: 'j9xjjY',
    description: 'Purchase Order Status Closed',
  },
  cancelled: {
    defaultMessage: 'Cancelled',
    id: 'q19sHN',
    description: 'Purchase Order Status Cancelled',
  },
  receiving: {
    defaultMessage: 'Receiving',
    id: '+wtKxM',
    description: 'Purchase Order Status Receiving',
  },
});
